import { mapGetters } from 'vuex'
import _ from 'lodash'
import { loadMicroApp, initGlobalState, runAfterFirstMounted } from 'qiankun'
import { STORE_AUTHORIZATION_NO_DISPLAY } from '@/store/mutation-types'
import store from '@/store'
// import {
//   findPane
// } from '@/store/_util/util'

const microApps = [
  {
    entry: process.env.VUE_APP_SSOWEB_ENTRY,
    // entry: 'http://localhost:8081',
    name: 'sso-web',
    systemCode: 'SSO_SYS_USER'
  }

]

const defaultMircoApp = 'sso-web'

const startMonitor = () => {
  !/proxy/.test(window.location.hostname) && createScript(process.env.VUE_APP_CNZZ)
}

const createScript = (url) => {
  let scriptElement = document.createElement('script')
  document.body.appendChild(scriptElement)
  scriptElement.src = url
}

// 第一个微应用 mount 后需要调用的方法，比如开启一些监控或者埋点脚
runAfterFirstMounted(() => startMonitor())

const microAppsMixin = {
  data () {
    return {
      loadedMicroApps: {},
      microAppStateActions: null
    }
  },
  computed: {
    ...mapGetters(['microApps', 'currentLang', 'isDemo', 'activeKey', 'menus', 'notification'])
  },
  methods: {
    loadMicroApp (appName) {
      if (!appName) return

      const that = this
      const { microApps, loadedMicroApps, menus } = this
      const { path, params: { serviceId, systemCode } } = this.$route
      const cacheKey = path.startsWith('/entry') ? `${serviceId}-${systemCode}-${appName}` : appName
      const appConfig = appName && microApps.find(app => app.name === appName)
      const appProps = {
        window,
        logout () {
          that.$store.dispatch('Logout')
        },
        /**
         * @description 通知提示框
         * @param {object} data - { type: 'success', message: '通知标题', description: '通知内容' }
         * @param {string} data.type - 类型 [success|error|info|warning|warn]
         * @param {string} data.message - 通知提醒标题，必选
         * @param {string} data.description - 通知提醒内容，必选
         * @param ... - 更多查阅https://antdv.com/components/notification-cn/
         */
        notification (data) {
          that.$notification(data)
        },
        globalErrorHandler (data) {
          const params = Object.assign({
            errorCode: 404,
            pageUrl: '-',
            systemCode: appConfig?.systemCode
          }, data)

          that.$store
            .dispatch('DingTalkNotice', params)
        },
        globalAuthSuccess (data) {
          this.$ls.set(STORE_AUTHORIZATION_NO_DISPLAY, true)
        },
        isDemo: that.isDemo,
        lang: that.currentLang,
        microApps: _.cloneDeep(microApps),
        menus: _.cloneDeep(menus)
      }

      if (path.startsWith('/entry')) {
        Object.assign(appProps, {
          navigator: {
            /**
             * @description 打开新标签
             * @param {object} data - { key: 'new', tab: '新增窗口', path: 'about:blank', closable: true }
             * @param {string} data.key - 唯一标识
             * @param {string} data.tab - 标签标题
             * @param {string} data.path - 标签路径
             * @param {boolean} data.closable - 是否可关闭，默认true
             */
            push (data) {
              const { path, ...other } = data
              const pane = {
                ...other,
                systemDomain: '',
                path: `/entry/${serviceId}/${systemCode}${path}`,
                noCache: true
              }
              that.$store.dispatch('entry/Navigator', pane)
            },
            /**
             * @param {object} data = { path: '/user/home', systemCode: 'SSO_SYS_USER', tab: '用户中心', menuName: { zh_CN: '用户中心', en_US: 'User Center' } }
             * @param {string} data.path - 跳转地址
             * @param {string} data.systemCode - 系统代码
             * @param {string} data.tab - 默认菜单名称（未匹配菜单名使用）
             * @param {object} data.menuName
             * @param {string} data.menuName.zh_CN
             * @param {string} data.menuName.en_US
             */
            pushByPath (data, done = () => {}) {
              const systemName = microApps.find(item => item.systemCode === data.systemCode)?.name
              const pane = {
                permissions: true,
                ...data,
                key: `${systemName}#${data.path}`,
                systemDomain: '',
                path: `/entry/${serviceId}/${systemCode}/${systemName}#${data.path}`,
                noCache: true
              }
              console.log('pane', pane)
              that.$store.dispatch('entry/SetActivePath', pane).then(() => done())
            },
            /**
             * @description 打开新页签（async）! 以下没有默认值的需任选一项或多项填写
             * @update 填写external可在iframe打开外链并创建新页签
             * @param {object=*}  data - { next, verify, systemCode, path, routerMethods, ... }
             * @param {string} data.path - 跳转地址
             * @param {string} data.systemCode - 子系统代码
             * @param {string} data.key - tab下标 （* 唯一值）
             * @param {string} data.functionClass - 权限标识符
             * @param {object} data.menuName - tab页签名称 { zh_CN: 'xxx', en_US: 'xxx_en', ko_KR: 'xxx_ko' }
             * @param {boolean=false} data.external - 打开外部地址 (仅限iframe打开)
             * @param {string} data.menuUrl - iframe.src (data.external为真有效)
             * @param {object} data.menuParams - iframe.src += &menuParams (data.external为真有效) { xx: 'xxx', xx: 'xxx' }
             * @param {boolean=false} data.relace - 打开新页面并替换当前tab页签
             * @param {boolean|string=warning} data.verify - 抛出Promise.reject (等于warning抛出错误提示)
             * @param {boolean=true} data.next - 执行路由跳转
             * @param {string =push}  data.routerMethods - 路由跳转方式 push | replace | go | back | forward
             * @param {function} done callback
             * @param {function} fail callback
             */
            pushByAsync (data, done = () => {}, fail = () => {}) {
              const systemName = microApps.find(item => item.systemCode === data.systemCode)?.name || 'iframe'
              const pane = {
                ...data,
                systemName,
                path: `/entry/${serviceId}/${systemCode}/${systemName}#${data.path || 'm_' + data.key}`
              }
              that.$store.dispatch('entry/SetActiveAsync', pane)
                .then(success => done(success))
                .catch(error => fail(error))
            },
            /**
             * @description 关闭标签
             * @param {object} data - { key: 'new' }
             * @param {string} data.key - 关闭标签的key值
             * @param {object} data.pane - 关闭后新开的标签
             */
            close ({ key, pane }) {
              const activeKey = key || that.$store.getters.activeKey
              that.$store.dispatch('entry/ClosePane', activeKey)
                .then(() => {
                  if (pane) {
                    that.$store.dispatch('entry/Navigator', {
                      ...pane,
                      systemDomain: '',
                      path: `/entry/${serviceId}/${systemCode}${pane.path}`
                    })
                  }
                })
            }
          }
        })
      }

      if (!loadedMicroApps[cacheKey] && appConfig) {
        loadedMicroApps[cacheKey] = loadMicroApp({
          container: `#${cacheKey}-view-box`,
          props: appProps,
          ...appConfig
        }, {
          // getTemplate (tpl) {
          //   const AMapScript = `<script type="text/javascript" src="https://webapi.amap.com/maps?v=2.0&key=cf0d803383ea8ae4d67cbc63fa0f5282">${'<'}/script>`
          //   const CNZZScript = `<script type="text/javascript" src="${process.env.VUE_APP_CNZZ}">${'<'}/script>`
          //   return tpl.replace(AMapScript, '').replace(CNZZScript, '')
          // }
        })
      }
    },
    mountMircoApp (cacheKey) {
      this.loadedMicroApps[cacheKey]?.mount()
    },
    unmountMircoApp (cacheKey) {
      if (this.loadedMicroApps[cacheKey]?.getStatus() === 'MOUNTED') {
        this.loadedMicroApps[cacheKey].unmount()
      }
    },
    refreshMircoApps () {
      for (let i of Object.keys(this.loadedMicroApps)) {
        const appName = i.replace(/(.*?-){2}/g, '')
        this.unmountMircoApp(i)
        delete this.loadedMicroApps[i]
        setTimeout(() => this.loadMicroApp(appName), 300)
      }
    }
  },
  mounted () {
    const { currentLang } = this
    this.microAppStateActions = initGlobalState({
      lang: currentLang,
      changeReadCount: false
    })
    this.microAppStateActions.onGlobalStateChange((state, prev) => {
      if (state.changeReadCount) {
        store.dispatch('queryMsgNoticePage')
      }
    })
  },
  watch: {
    currentLang (lang) {
      this.microAppStateActions.setGlobalState({
        lang
      })
    },
    notification (notification) {
      this.microAppStateActions.setGlobalState({
        noReadCount: notification.noReadCount,
        changeReadCount: false
      })
    }
  }
}

export default microApps
export { defaultMircoApp, microAppsMixin }
